<template lang='pug'>
  .pagination-container(:class='{ "full": full }')
    nav.pagination
      a.page.prev(v-if='currentPage > 1' @click.prevent='setPage(currentPage - 1)')

      template(v-if='full')
        a.page(v-if='currentPage > 2' @click.prevent='setPage(1)') 1
        a.page(v-if='pageCount > 3 && currentPage === pageCount' @click.prevent='setPage(2)') 2
        a.page.continue(v-if='currentPage > 3 && pageCount > 4') ...

      template(v-if='!full')
        a.page(v-if='currentPage === pageCount && pageCount > 2' @click.prevent='setPage(currentPage - 2)') {{ currentPage - 2 }}

      a.page(v-if='currentPage > 1' @click.prevent='setPage(currentPage - 1)') {{ currentPage - 1 }}
      a.page.current {{ currentPage }}
      a.page(v-if='currentPage + 1 <= pageCount' @click.prevent='setPage(currentPage + 1)') {{ currentPage + 1 }}

      template(v-if='!full')
        a.page(v-if='currentPage === 1 && pageCount > 2' @click.prevent='setPage(3)') 3

      template(v-if='intervalToLastPage !== 0 && full')
        a.page.continue(v-if='intervalToLastPage > 2 && pageCount > 4') ...
        a.page(v-if='currentPage === 1 && pageCount > 3' @click.prevent='setPage(pageCount - 1)') {{ pageCount - 1 }}
        a.page(v-if='currentPage + 1 < pageCount' @click.prevent='setPage(pageCount)') {{ pageCount }}

      a.page.next(v-if='currentPage !== pageCount' @click.prevent='setPage(currentPage + 1)')
</template>

<script>
export default {
  props: [
    // Refer to Style Guide for example of full vs non-full pagination: https://www.sephora.sg/style-guide
    // true when showing the whole pagination with first / last page and ... for extra pages
    // false when showing the abbreviated version of pagination with only next / prev and arrows
    'full',
    'startPage',
    'pageCount',
    'scrollTo',
    'scrollOffset'
  ],

  data () {
    return {
      currentPage: this.startPage
    }
  },

  computed: {
    intervalToLastPage () {
      return this.pageCount - this.currentPage
    }
  },

  watch: {
    startPage () {
      this.currentPage = this.startPage
    }
  },

  methods: {
    setPage (page) {
      if (this.full && this.scrollTo) {
        this.$scrollTo(this.scrollTo, 300, {
          offset: this.scrollOffset || 0
        })
      }
      this.currentPage = page
      this.$emit('setPage', page, this.full)
    }
  }
}
</script>

<style lang='scss' scoped>
  .pagination-container {
    display: inline-block;

    @include media-breakpoint-only(md) {
      display: none;
    }

    &.full {
      display: block;
      text-align: center;

      @include media-breakpoint-up(md) {
        margin-top: -5px;
        text-align: right;
      }
    }
  }
</style>
